module.exports = __webpack_public_path__ + "static/media/consultancy.c2dc1626.png";